import { render } from "./QuestionedTable.vue?vue&type=template&id=747d42ff"
import script from "./QuestionedTable.vue?vue&type=script&lang=js"
export * from "./QuestionedTable.vue?vue&type=script&lang=js"

import "./QuestionedTable.vue?vue&type=style&index=0&id=747d42ff&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__